module.exports = require("./ru-KG.d.ts");